module.exports = __webpack_public_path__ + "494cd07c/img/settings-ico.a214628d.svg";